import React, {
    FC,
    useState,
} from "react";
import {
    Box,
    CircularProgress,
    Grid,
    Typography,
} from "@mui/material";
import {NoData} from "../table/NoData";
import {IdlocaGeneric} from "../../locales/IdlocaGeneric";
import {RoutesPath} from "../../enums/RoutesPath";
import {ButtonTableView} from "../buttons/ButtonTableView";
import {CatalogueContent} from "../catalogue/list/CatalogueContent";
import {ViewTableStyle} from "../../enums/ViewTableStyle";
import {Locale} from "../../locales/Locale";
import {useFavourites} from "./FavouritesContext";

export const Favourites: FC = () => {

    const {favouritesIds, favouritesList, favouritesLoading, toggleFavourite} = useFavourites();

    const [viewStyle, setViewStyle] = useState<ViewTableStyle>(ViewTableStyle.LIST);

    if (favouritesLoading) {
        return (
            <Grid item xs={12} sx={{display: "flex", justifyContent: "center", paddingTop: "2rem"}}>
                <CircularProgress/>
            </Grid>
        );
    }

    return (
        <Box sx={{marginTop: "16px"}}>
            <Typography variant="subtitle1">
                <Locale localeId={IdlocaGeneric.favourites}/>
            </Typography>
            {favouritesList.length === 0 ? (
                <NoData
                    messageLocaId={IdlocaGeneric.no_favourites}
                    redirectButtonLocaId={IdlocaGeneric.go_to_catalogue}
                    redirectUrl={RoutesPath.CATALOGUE}
                />
            ) : (
                <>
                    <ButtonTableView viewStyle={viewStyle} setViewStyle={setViewStyle}/>
                    <CatalogueContent
                        motorcycles={favouritesList ?? null}
                        dataLoading={favouritesLoading}
                        viewStyle={viewStyle}
                        favourites={favouritesIds}
                        toggleFavourites={toggleFavourite}
                    />
                </>
            )}
        </Box>
    );
};
